import { destroy, stopSubmit } from 'redux-form'
import {
  all,
  call,
  put,
  select,
  take,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects'
import {
  eventWasDeleted,
  IEventWasDeleted,
} from '../../actions/bookingCalendar/event/requestDeleteEvent'
import { callFetch } from '../../actions/fetch'
import { fireToastError } from '../../actions/toasts/fireToast'
import fireToastSuccess from '../../actions/toasts/fireToastSucces'
import { database } from '../../database'
import i18n from '../../i18n'
import requestDelete from '../../models/Event/deleteEvent'
import { EventActions } from '../../reducers/bookingCalendar/actionNames'
import { getUpdateModalReservationId } from '../../reducers/bookingCalendar/selectors/getModalOpen'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import { Mixpanel } from '../../utils/Mixpanel'
import { getUserId } from '../../reducers/userAccount/selectors/userAccount'

function* deleteEvent(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.DeleteEvent)
    const [{ service }, selectedEvent] = yield all([
      take(actionNames.output),
      select(getUpdateModalReservationId),
      put(callFetch(actionNames.input, actionNames.output, requestDelete)),
    ])

    const userId = yield select(getUserId)

    yield call(service, action.eventId ? action.eventId : selectedEvent)

    yield all([
      destroy('update_reservation'),
      put(eventWasDeleted(action.eventId ? action.eventId : selectedEvent)),
    ])
    yield put(fireToastSuccess(i18n.t('reservation_deleted')))

    Mixpanel.track('Reservation Delete Completed', {
      'Reservation ID': action.eventId
        ? Number(action.eventId)
        : Number(selectedEvent),
    })
    Mixpanel.people.increment(userId, 'Reservations Deleted', 1)
  } catch (e) {
    console.log(e)
    yield stopSubmit('update_reservation', e)
    yield put(fireToastError(i18n.t('cannot_remove_event')))
  }
}

function* deleteEventfromDb(action: IEventWasDeleted) {
  yield database.events.update(action.eventId.toString(), {
    isDeleted: true,
  })
}

export default function*() {
  yield takeLatest(EventActions.RequestDeleteEvent, deleteEvent)
  yield takeEvery(EventActions.EventWasDeleted, deleteEventfromDb)
}
